var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{staticClass:"teal darken-2  mr-2",attrs:{"fab":"","small":"","dark":""},nativeOn:{"click":function($event){return _vm.print()}}},[_c('v-icon',[_vm._v("mdi-printer")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }